import { CenteredModal } from '@app/core';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';

const useStyles = createUseStyles((theme: Theme) => ({
  content: {
    lineHeight: 1.6,
    maxHeight: '70vh',
    overflowY: 'auto',
    paddingRight: theme.marginBase,
    '& ul': {
      marginLeft: theme.marginBase * 3,
      paddingLeft: theme.marginBase * 2,
      marginBottom: theme.marginBase * 2,
      '& li': {
        marginBottom: theme.marginBase * 0.5,
      },
    },
  },
  intro: {
    marginBottom: theme.marginBase * 3,
  },
  section: {
    marginBottom: theme.marginBase * 3,
    '& h4': {
      ...theme.fonts.h4,
      marginBottom: theme.marginBase * 2,
    },
    '& p': {
      marginBottom: theme.marginBase,
    },
  },
  separator: {
    border: 'none',
    borderTop: `1px solid ${theme.colors.inkPrimary}`,
    margin: `${theme.marginBase * 3}px 0`,
  },
}));

interface Props {
  isOpen: boolean;
  onRequestClose: () => void;
}

export const GdprRuleModal = ({ isOpen, onRequestClose }: Props) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <CenteredModal
      title={t('editSession.screening.gdpr.document.title')}
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      xlarge
    >
      <div className={classes.content}>
        <p className={classes.intro}>
          <Trans
            i18nKey="editSession.screening.gdpr.document.intro"
            components={{ strong: <strong /> }}
          />
        </p>

        <div className={classes.section}>
          <h4>1. {t('editSession.screening.gdpr.document.subTitleOne')}</h4>
          <p>{t('editSession.screening.gdpr.document.introOne')}</p>
          <Trans
            i18nKey="editSession.screening.gdpr.document.parOne"
            components={{ ul: <ul />, li: <li /> }}
          />
        </div>

        <div className={classes.section}>
          <h4>2. {t('editSession.screening.gdpr.document.subTitleTwo')}</h4>
          <p>
            <Trans
              i18nKey="editSession.screening.gdpr.document.introTwo"
              components={{ strong: <strong /> }}
            />
          </p>
          <Trans
            i18nKey="editSession.screening.gdpr.document.parTwo"
            components={{ p: <p />, ul: <ul />, li: <li /> }}
          />

          <div>
            <p>
              <Trans
                i18nKey="editSession.screening.gdpr.document.advice"
                components={{
                  strong: <strong />,
                }}
              />
            </p>
          </div>
          <Trans
            i18nKey="editSession.screening.gdpr.document.example"
            components={{
              p: <p />,
              strong: <strong />,
              ul: <ul />,
              li: <li />,
            }}
          />
        </div>

        <div className={classes.section}>
          <h4>3. {t('editSession.screening.gdpr.document.subTitleThree')}</h4>
          <p>
            <Trans
              i18nKey="editSession.screening.gdpr.document.parThree"
              components={{ strong: <strong /> }}
            />
          </p>
        </div>

        <hr className={classes.separator} />

        <div>
          <p>
            <Trans
              i18nKey="editSession.screening.gdpr.document.disclaimer"
              components={{
                strong: <strong />,
              }}
            />
          </p>
        </div>
      </div>
    </CenteredModal>
  );
};
